import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import * as Styled from './Message.style';
import { markdownComponents } from '../utils/markdownComponents';

/**
 * A component for displaying message blocks with consistent styling and optional animations
 * @param {object} props - Component props
 * @param {string} props.message - The message text to display
 * @param {string} [props.type='primary'] - The type/color of message for styling
 * @param {string} [props.size='sm'] - The size of the message text
 */

function Message({ message, type = 'primary', size = 'md', variant = 'plain' }) {
  return (
    <Styled.MessageRoot variant={variant}>
      <Styled.MessageText color={`${type}`} size={size}>
        <ReactMarkdown components={markdownComponents} rehypePlugins={[rehypeRaw]}>
          {message}
        </ReactMarkdown>
      </Styled.MessageText>
    </Styled.MessageRoot>
  );
}

Message.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'info', 'warning', 'error', 'success']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl']),
  variant: PropTypes.oneOf(['plain', 'card'])
};

export default Message;
